import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';
import CreditCardModel from './CreditCardModel';
import WalletMethodModel from './WalletMethodModel';

export default Backbone.Collection.extend({
  url() {
    return Rover.urls.paymentMethods;
  },
  initialize(options) {
    this.on('sync', this.breakoutMethods, this);
    this.creditCardCollection = options.creditCardCollection;
    this.roverBucksModel = options.roverBucksModel;
  },
  breakoutMethods() {
    const that = this;
    const creditCards = [];

    this.roverBucksModel.clearRoverBucksMethods();

    _.each(this.models, model => {
      const type = model.get('type');
      if (type === 'wallet') {
        const m = new WalletMethodModel(model.toJSON());
        that.roverBucksModel.addRoverBucksMethod(m);

        that.roverBucksModel.set(model.toJSON());
      } else if (type === 'promo') {
        const m = new Rover.models.PromoMethodModel(model.toJSON());
        that.roverBucksModel.addRoverBucksMethod(m);
      } else if (type === 'creditcard') {
        const creditCardModel = new CreditCardModel(model.toJSON());
        if (creditCardModel.get('expired') !== true) {
          creditCards.push(creditCardModel);
        }
      }
    });
    if (that.creditCardCollection) {
      that.creditCardCollection.reset(creditCards);
    }
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/PaymentMethodCollection.js